import { render, staticRenderFns } from "./PeopleTable.vue?vue&type=template&id=f4c81428&"
import script from "./PeopleTable.vue?vue&type=script&lang=js&"
export * from "./PeopleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports